import React from "react";
import { motion } from "framer-motion";
import { INQUIRIES } from "@/constants/testIds";
import { SITE } from "@/lib/site";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 1.05, ease: [0.22, 0.61, 0.36, 1], delay: i * 0.12 },
  }),
};

const ProfessionalInquiries = () => {
  return (
    <section
      id="professional-inquiries"
      data-testid={INQUIRIES.section}
      className="relative w-full py-28 md:py-40 lg:py-48"
      style={{ background: "var(--soti-surface)" }}
    >
      <div className="absolute inset-x-0 top-0 h-px" style={{ background: "var(--soti-rule)" }} />
      <div className="absolute inset-x-0 bottom-0 h-px" style={{ background: "var(--soti-rule)" }} />

      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-16 text-center">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          custom={0}
          className="flex flex-col items-center gap-5"
        >
          <span className="rule rule-cinder" aria-hidden="true" />
          <p className="overline">For Press, Rights & Editorial</p>
        </motion.div>

        <motion.h2
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          custom={1}
          data-testid={INQUIRIES.heading}
          className="font-display text-[#F3EFEA] mt-10 text-4xl sm:text-5xl md:text-6xl leading-[1.04] tracking-[-0.02em]"
        >
          Professional Inquiries
        </motion.h2>

        <motion.p
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          custom={2}
          data-testid={INQUIRIES.body}
          className="mt-10 max-w-xl mx-auto text-[#A19D99] text-base sm:text-lg leading-relaxed font-light"
        >
          For rights, press, review, editorial, or professional inquiries,
          please use the listed email.
        </motion.p>

        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          custom={3}
          className="mt-12"
        >
          <a
            data-testid={INQUIRIES.email}
            href={`mailto:${SITE.inquiriesEmail}`}
            className="font-display italic text-[#F3EFEA] text-2xl sm:text-3xl md:text-4xl link-cinder"
          >
            {SITE.inquiriesEmail}
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ProfessionalInquiries;
